import { CheckBox } from 'src/UI';
import { ReactComponent as ExpandIcon } from './ExpandIcon.svg';
import './expand-column.scss';
import classNames from 'classnames';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

interface ExpandColumnProps {
	isExpand?: boolean;
	rowId: string;
	onExpand: (rowId: string) => void;
	render?: ( isExpand: boolean, onExpandHandler: () => void ) => React.ReactNode;
	rowExpanding?: boolean;
	checkBoxesMode?: boolean;
	selectedRecords?: string[];
	onRowSelect: () => void;
};

/** Отрисовка ячейки с туглером  раскрытия строки */
export const ExpandColumnCell: React.FC<ExpandColumnProps> = ({ isExpand = false, rowExpanding = false, rowId, selectedRecords = [], checkBoxesMode = false, onRowSelect, render, onExpand  }) => {

	const cellRef = useRef<HTMLTableCellElement>(null);
	const [ foundOverflowInRow, setFoundOverflowInRow ] = useState<boolean>(false);

	useEffect( () => {
		if ( !rowExpanding ) return;
		checkOverflow();
	}, [ rowExpanding, isExpand ] );

	const expandRowHandler: React.MouseEventHandler<HTMLButtonElement> = (e)  => {
		e.preventDefault();
		e.stopPropagation();
		onExpand(rowId);
	};

	const onToggleSelectedHandler: React.MouseEventHandler = (e) => {
		if ( !checkBoxesMode ) return;
		e.preventDefault();
		e.stopPropagation();
		onRowSelect();
	};

	const checkOverflow = () => {
		let _foundOverflowInRow = false;
		if ( isExpand ) {
			_foundOverflowInRow = true;
		}
		else {
			const row = cellRef?.current?.parentElement;
			if ( !!row ) {
				const dataCells = row.querySelectorAll('td[is-data-cell="true"]>.rdc_table__cell>div');
				dataCells?.forEach( cell => {
					if (!(cell instanceof HTMLElement)) return;
					const isOverflowing = cell.scrollWidth > cell.clientWidth;
					isOverflowing && (_foundOverflowInRow = true);
				});
			}
		}
		setFoundOverflowInRow( _foundOverflowInRow );
	};

	const renderCheckBox = () => (
		<CheckBox
			name={"chb_" + rowId}
			value={selectedRecords.includes(rowId)}
		/>
	);

	const renderExpandBtn = () => {
		if ( !rowExpanding || !foundOverflowInRow ) return null;
		if ( render ) {
			return render( isExpand, () => onExpand(rowId) );
		}
		else 
			return (
				<button id={ "btn_expand-" + rowId } onClick={expandRowHandler} >
					<ExpandIcon style={{ transition: 'all 0.2s', transform: isExpand ? 'rotate(180deg)' : '' }} />
				</button>
			);
	};

	return (
		<td ref={cellRef} className='rdct_expand' onClick={onToggleSelectedHandler}>
			<div className={classNames("rdct_expand-cell_wrapper", { "with-chb": (checkBoxesMode && rowExpanding) } )}>
				{ checkBoxesMode && renderCheckBox() }
				{ renderExpandBtn() }
			</div>
		</td>
	);
};